import { render, staticRenderFns } from "./IrisQuickActionButtonContainer.vue?vue&type=template&id=2f2c71e8&"
import script from "./IrisQuickActionButtonContainer.vue?vue&type=script&lang=ts&"
export * from "./IrisQuickActionButtonContainer.vue?vue&type=script&lang=ts&"
import style0 from "./IrisQuickActionButtonContainer.vue?vue&type=style&index=0&id=2f2c71e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports